import { render, staticRenderFns } from "./classical-announcement-upload.vue?vue&type=template&id=0b28c094"
import script from "./classical-announcement-upload.vue?vue&type=script&lang=js"
export * from "./classical-announcement-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports